import deepmerge from 'deepmerge';
import {getIsAgeRestricted} from '../../../common/getIsAgeRestricted';
import {Text} from '../../../design-system/atoms/Text/Text';
import {NormalListViewItem} from '../../../design-system/organisms/NormalListViewItem/NormalListViewItem';
import {RightButtonType} from '../../../design-system/organisms/NormalListViewItem/RightButtonType.enum';
import {
  Maybe,
  NormalListViewItem as NormalListViewItemType,
} from '../../../graphql/generated/types';
import {aggregateAndSendLog} from '../../../logging/aggregateAndSendLog';
import {putTiaraObjectProps} from '../../../logging/putTiaraObjectProps';
import {userActionStr} from '../../../logging/TrackEventObject.interface';
import {useLogin} from '../../../user/useLogin.hook';
import {useClickGiftButton} from '../hook/useClickGiftButton';

export function TodayGiftPromotionListContainer({
  currentCategoryUid,
  currentCategoryName,
  currentSubCategoryName,
  currentSubCategoryUid,
  list,
  title,
}: {
  currentCategoryUid: string;
  currentCategoryName?: string;
  currentSubCategoryName?: string;
  currentSubCategoryUid?: string;
  list: NormalListViewItemType[];
  title?: Maybe<string>;
}) {
  const categoryUid = currentCategoryUid;
  const subCategoryUid = currentSubCategoryUid;
  const {onClickGiftButton} = useClickGiftButton({categoryUid, subCategoryUid});
  const {user} = useLogin();

  return (
    <div className="mx-11pxr mb-8pxr flex flex-col justify-center rounded-8pxr bg-theme-solid-10 pt-10pxr pb-5pxr">
      {title && (
        <Text className="font-small1-bold mb-5pxr text-ellipsis px-11pxr text-theme-solid-100 line-clamp-1">
          {title}
        </Text>
      )}
      <div className="flex flex-col justify-center">
        {list.map((item, idx) => (
          <NormalListViewItem
            key={item.id}
            item={item}
            // TODO: 선물함 Legacy 컴포넌트들 모두 제거 시 NormalListViewItem 내부로 스타일 넣어주기
            className="px-11pxr"
            isAgeRestricted={getIsAgeRestricted({
              age: user?.age,
              authenticatedAt: user?.authenticatedAt,
              ageGrade: item.ageGrade,
              selfCensorship: item.selfCensorship,
            })}
            imageLazyLoad={true}
            rightButton={{
              type: RightButtonType.Gift,
              isActive: item.isReceived,
              rounded: true,
            }}
            onClickRightButton={e => {
              const giftItemLogObj = {
                customProps: {
                  user_action: 'click' as userActionStr,
                },
              };
              if (!item.isReceived) {
                e.preventDefault();
                e.stopPropagation();
                aggregateAndSendLog({
                  targetElem: e.target as HTMLElement,
                  actionType: 'Event',
                  actionName: '선물받기_클릭',
                  ...(item.giftEventLog
                    ? deepmerge(item.giftEventLog, giftItemLogObj)
                    : giftItemLogObj),
                });
                onClickGiftButton({
                  ticketUid: item.ticketUid,
                  seriesId: item.seriesId,
                  title: item.row1,
                  ageGrade: item.ageGrade,
                });
              }
            }}
            onClick={e => {
              const todayGiftItemLogObj = {
                customProps: {
                  user_action: 'click' as userActionStr,
                },
              };
              aggregateAndSendLog({
                targetElem: e.target as HTMLElement,
                actionType: 'Event',
                actionName: '작품_클릭',
                ...(item.eventLog
                  ? deepmerge(item.eventLog, todayGiftItemLogObj)
                  : todayGiftItemLogObj),
              });
            }}
            onClickContinueView={e => {
              const todayGiftItemLogObj = {
                customProps: {
                  user_action: 'click' as userActionStr,
                },
              };
              aggregateAndSendLog({
                targetElem: e.target as HTMLElement,
                actionType: 'Event',
                actionName: '작품_클릭',
                ...(item.eventLog
                  ? deepmerge(item.eventLog, todayGiftItemLogObj)
                  : todayGiftItemLogObj),
              });
            }}
            {...putTiaraObjectProps({
              click: {
                layer1: '프로모션영역',
                ordnum: String(idx + 1),
              },
              customProps: {
                page_category_filter: currentCategoryName,
                page_genre_filter: currentSubCategoryName,
              },
            })}
          />
        ))}
      </div>
    </div>
  );
}
